import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { URL_API } from "../shared/consts";
import { redirectLogin } from "../utils/functions.util";

/** THUNKS */
export const getCompanyList = createAsyncThunk(
  "company/getCompanyList",
  async (values, { rejectWithValue }) => {
    try {
      const { page, size, search } = values;
      const filter = Object.entries(search);
      if (filter.length) {
        const res = await axios.post(
          `${URL_API}/companies/search`,
          {
            filters: search,
            page: page,
            size: size,
          },
          {
            withCredentials: true,
          }
        );
        return res.data;
      }
      const res = await axios.get(
        `${URL_API}/companies?page=${page}&size=${size}`,
        {
          withCredentials: true,
        }
      );
      return res.data;
    } catch (error) {
      redirectLogin(error?.response?.status);
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message;
      return rejectWithValue(message);
    }
  }
);
export const createCompany = createAsyncThunk(
  "company/createCompany",
  async (values, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${URL_API}/companies`, values, {
        withCredentials: true,
      });
      return res.data;
    } catch (error) {
      redirectLogin(error?.response?.status);
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message;
      return rejectWithValue(message);
    }
  }
);
export const updateCompany = createAsyncThunk(
  "company/updateCompany",
  async (values, { rejectWithValue }) => {
    try {
      const { id } = values;
      const res = await axios.put(`${URL_API}/companies/${id}`, values, {
        withCredentials: true,
      });
      return res.data;
    } catch (error) {
      redirectLogin(error?.response?.status);
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message;
      return rejectWithValue(message);
    }
  }
);
export const deleteCompany = createAsyncThunk(
  "company/deleteCompany",
  async (values, { rejectWithValue }) => {
    try {
      const { id } = values;
      const res = await axios.delete(`${URL_API}/companies/${id}`, {
        withCredentials: true,
      });
      return res.data;
    } catch (error) {
      redirectLogin(error?.response?.status);
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message;
      return rejectWithValue(message);
    }
  }
);
